var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"PLATFORM ADMINISTRATION","title":"EduSchool Portal","description":"Manage school subjects, learning resources, notifications and school community content.","count-label":"portal tools"}},[_c('Submenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }